<template>
   <span :style="{marginRight: margin, color: active ? 'var(--good)' : 'var(--g1)'}">●</span>       
</template>
<!-- <MenuDot active></MenuDot> -->
<script>


export default {
    data: function () {return {}},
    props:{
        active: Boolean,
        margin: {type:String, default:'0px'},
    },    
}
</script>
<style scoped>
    
</style>